import { useEffect } from "react";
import type { i18n as I18nInstance } from "i18next";
import { hasStoredOverride, type Locale } from "./locale";

/**
 * Applies `users.locale` once a session resolves — but only when steps 1-2
 * of the resolution chain (the `?lang=` / localStorage override) haven't
 * already picked a locale. Does not itself persist an override: this is a
 * passive sync from server state, not an explicit user choice.
 */
export function useSyncUserLocale(i18n: I18nInstance, userLocale: Locale | null | undefined): void {
  useEffect(() => {
    if (!userLocale) return;
    if (hasStoredOverride()) return;
    if (i18n.language === userLocale) return;
    void i18n.changeLanguage(userLocale);
  }, [i18n, userLocale]);
}
